import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import routes from "./routes";
import "./assets/scss/theme.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./pages/Admin/Context/AuthContext";

import "./assets/css/index.css";
import "./assets/css/header-footer.css";
import ScrollToTop from "./utils/ScrollToTop";

function App() {
  // Recursive renderer (only needed if you nest routes in routes.js)
  const renderRoutes = (routes) =>
    routes.map((route, index) => (
      <Route key={index} path={route.path} element={route.element}>
        {route.children && renderRoutes(route.children)}
      </Route>
    ));

  return (
    <AuthProvider>
       <ToastContainer /> 
        <Router>
           <ScrollToTop base="/user" />
          <div className="App">
            <Routes>{renderRoutes(routes)}</Routes>
          </div>
         
        </Router>
    
    </AuthProvider>
  );
}

export default App;
